import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text, Message } from 'components/chroma';

const PortableContentsModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal header="Portable Contents Cover" isOpen={isOpen} onClose={onClose}>
    <Message error>
      <Text>
        Portable contents cover cannot be removed once Specified and/or
        Unspecified portables have been added.
      </Text>
    </Message>
  </Modal>
);

export default PortableContentsModal;
